export const clampCurrency = (value: number): number => {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.max(0, Math.round(value));
};

export const calculateCardSurchargeCents = (
  subtotalCents: number,
  surchargePercent: number,
): number => {
  if (!Number.isFinite(subtotalCents) || subtotalCents <= 0) {
    return 0;
  }
  if (!Number.isFinite(surchargePercent) || surchargePercent <= 0) {
    return 0;
  }
  return clampCurrency((subtotalCents * surchargePercent) / 100);
};

export const formatCardSurchargeLabel = (surchargePercent: number): string | null => {
  if (!Number.isFinite(surchargePercent) || surchargePercent <= 0) {
    return null;
  }
  return `${surchargePercent.toFixed(2)}%`;
};
